import {ItemCountView} from '../../../../shared/scripts/ui_canvas_engine/ItemCountView'
import {UIGamePlayerInformationProgressCardVictoryPointView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationProgressCardVictoryPointView'
import {UIGameSpriteHandler} from '../../../../shared/scripts/UIGameSpriteHandler'
import {Sprites} from '../../../../shared/scripts/ui_game/UIGameImageDictionary'

export class UIWGamePlayerInformationProgressCardVictoryPointView extends UIGamePlayerInformationProgressCardVictoryPointView {
    protected createMyProgressCardVictoryPointView() {
        const playerInformationW = this.playerInformation.width
        const playerInformationH = this.playerInformation.height

        const progressCardVictoryPointX = playerInformationW * 0.809
        const progressCardVictoryPointY = playerInformationH * 0.4267
        const progressCardVictoryPointW = playerInformationW * 0.0804
        const progressCardVictoryPointH = playerInformationH * 0.22

        const progressCardVictoryPointCountX = playerInformationW * 0.8943
        const progressCardVictoryPointCountY = progressCardVictoryPointY
        const progressCardVictoryPointCountW = playerInformationW * 0.1
        const progressCardVictoryPointCountH = progressCardVictoryPointH

        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_trophy)
        const iconPadding = -progressCardVictoryPointW * 0.0786
        this.progressCardVictoryPointView = new ItemCountView(progressCardVictoryPointX, progressCardVictoryPointY, progressCardVictoryPointW, progressCardVictoryPointH, this.playerInformation, texture,
            progressCardVictoryPointCountX, progressCardVictoryPointCountY, progressCardVictoryPointCountW, progressCardVictoryPointCountH, iconPadding)
        this.progressCardVictoryPointView.resetTextYPosition()
    }

    protected createOpponentProgressCardVictoryPointView() {
        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_trophy)
        const playerInformationW = this.playerInformation.width
        const playerInformationH = this.playerInformation.height

        const progressCardVictoryPointX = playerInformationW * 0.809
        const progressCardVictoryPointY = playerInformationH * 0.1045
        const progressCardVictoryPointW = playerInformationW * 0.0804
        const progressCardVictoryPointH = playerInformationH * 0.341

        const progressCardVictoryPointCountX = playerInformationW * 0.8943
        const progressCardVictoryPointCountY = progressCardVictoryPointY
        const progressCardVictoryPointCountW = playerInformationW * 0.1
        const progressCardVictoryPointCountH = progressCardVictoryPointH

        const iconPadding = -progressCardVictoryPointW * 0.078
        this.progressCardVictoryPointView = new ItemCountView(progressCardVictoryPointX, progressCardVictoryPointY, progressCardVictoryPointW, progressCardVictoryPointH, this.playerInformation, texture,
            progressCardVictoryPointCountX, progressCardVictoryPointCountY, progressCardVictoryPointCountW, progressCardVictoryPointCountH, iconPadding)
        this.progressCardVictoryPointView.resetTextYPosition()
    }
}
